import React from 'react';
type SectionHeadingProps = {
  eyebrow?: string;
  title: string;
  intro?: string;
  onDark?: boolean;
  align?: 'left' | 'center';
  action?: React.ReactNode;
};
export function SectionHeading({
  eyebrow,
  title,
  intro,
  onDark = false,
  align = 'left',
  action
}: SectionHeadingProps) {
  return <div className={`flex flex-col gap-6 ${align === 'center' ? 'items-center text-center' : 'md:flex-row md:items-end md:justify-between'}`} data-id="element-602" data-mp="ryj45v4lbzoz">
      <div className={align === 'center' ? 'max-w-2xl' : 'max-w-2xl'} data-id="element-603" data-mp="i7g48wnedqra">
        {eyebrow && <p className={`mb-3 flex items-center gap-2.5 font-sans text-[13px] font-semibold ${align === 'center' ? 'justify-center' : ''} ${onDark ? 'text-gold-300' : 'text-green-700'}`} data-id="element-604" data-mp="d8bvu88arx20">
            <span aria-hidden className="h-px w-6 bg-current opacity-60" data-id="element-605" data-mp="47njrj2gs6rr" />
            {eyebrow}
          </p>}
        <h2 className={`font-display text-[30px] leading-[1.12] tracking-[-0.02em] sm:text-[36px] lg:text-[42px] ${onDark ? 'text-white' : 'text-ink'}`} data-id="element-606" data-mp="3vgkubkdxdx3y">
          {title}
        </h2>
        {intro && <p className={`mt-4 text-[17px] leading-relaxed ${onDark ? 'text-white/70' : 'text-slate-600'}`} data-id="element-607" data-mp="150nshxb8gwws">
            {intro}
          </p>}
      </div>
      {action && <div className="shrink-0" data-id="element-608" data-mp="1wrk4kvpgyxj0">{action}</div>}
    </div>;
}